import {t} from 'i18next';
import {InputText} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import {CriteriaTextComponent} from '../components/criteria/CriteriaTextComponent';
import GroupService from '../services/GroupService';
import UserRoleService from '../services/UserRoleService';
import AppPrefixUtils from '../utils/AppPrefixUtils';
import StringUtils from '../utils/StringUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class GroupsListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new GroupService());
        this.service = new GroupService();
        this.roleService = new UserRoleService();
        this.state = {
            usersDialog: false,
            dialogVisible: false,
            dialogAddGroup: false,
            dialogDeleteVisibile: false,
            dialogViewMode: undefined,
            list: [],
            loading: true,
            checked: true,
            unchecked: false,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            settingParameterTypeOptions: [],
            settingGroupTypeOptions: [],
            newGroup: undefined,
            element: {
                name: undefined,
                id: undefined,
            },
        };
        this.onRowEditComplete = this.onRowEditComplete.bind(this);
        this.handleDeleteRow = this.handleDeleteRow.bind(this);
        this.handleEditRow = this.handleEditRow.bind(this);
        this.actionTemplate = this.actionTemplate(this);
        this.handleOpenRemoveDialog = this.handleOpenRemoveDialog.bind(this);
        this.hideDeleteDialog = this.hideDeleteDialog.bind(this);
        this.onRemoveAction = this.onRemoveAction.bind(this);
        this.handleOpenNewGroupDialog = this.handleOpenNewGroupDialog.bind(this);
        this.handleCloseGroupDialog = this.handleCloseGroupDialog.bind(this);
        this.createOrUpdate = this.createOrUpdate.bind(this);
        this.handleOpenGroupUsersDialog = this.handleOpenGroupUsersDialog.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.text,
            id: criteria.id,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }
    getCleanSearchCriteria() {
        return {
            name: '',
            id: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'name',
            sortAsc: true,
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'groups.listTitle';
    }
    getCriteriaName() {
        return 'groups-list-sc';
    }

    showDeleteDialog() {
        this.setState({
            dialogVisibile: true,
        });
    }
    afterRowSelected(e) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${e?.value[0].id}`;
        this.handleGoToDetail(detailHref, e.originalEvent);
    }
    hideDeleteDialog(callBack) {
        this.setState({removeDialog: false, idToRemove: null}, () => {
            if (callBack) callBack();
        });
    }

    getContainerListName() {
        return 'groups-list-container';
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    label={t('setting.name')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    placeholder={t('list.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
            </div>
        );
    }

    parameterEditor(options) {
        return (
            <div>
                {' '}
                <InputText type='text' value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />
                {StringUtils.isBlank(options.value) ? (
                    <small id='username2-help' className='p-error block'>
                        {t('list.emptyField')}
                    </small>
                ) : null}
            </div>
        );
    }

    onRemoveAction(callback) {
        this.blockUi();
        this.service
            .remove(this.state.idToRemove)
            .then(() => {
                this.unblockUi();
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.hideRemoveConfirmation();
            });
    }

    handleOpenRemoveDialog(e, idToRemove) {
        if (e) {
            e.preventDefault();
        }
        this.setState({removeDialog: true, idToRemove});
    }
    handleOpenGroupUsersDialog(e, elementId) {
        if (e) {
            e.preventDefault();
        }
        this.setState({usersDialog: true, dialogViewMode: 'VIEW', elementId});
        window.console.log(this.state.usersDialog);
    }
    handleCloseGroupUsersDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({usersDialog: false, groupId: undefined}, () => {
            if (callback) callback();
        });
    }

    handleCloseUserDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({usersDialog: false, elementId: undefined}, () => {
            if (callback) callback();
        });
    }
    handleOpenNewGroupDialog() {
        this.setState({
            dialogAddGroup: !this.state.dialogAddGroup,
        });
    }

    handleCloseGroupDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisible: false, elementId: undefined}, () => {
            if (callback) callback();
        });
    }

    actionTemplate(rowData) {
        window.console.log(rowData);
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${rowData?.elementId}`;
        return (
            <div>
                <ActionLink
                    className='p-link float-right'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
            </div>
        );
    }
    onRowEditComplete(e) {
        if (!e.newData.name || StringUtils.isBlank(e.newData.name)) {
            this.showErrorMessage(t('list.emptyField'));
            return;
        }
        this.service
            .update({id: e.data.id, name: e.newData.name})
            .then((response) => {
                this.showSuccessMessage(t('groups.nameEdited'));
                this.refreshTable();
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
            });
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}`;
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('global.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(href);
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {
                field: 'name',
                editor: (options) => this.parameterEditor(options),
                header: t('mobileUser.name'),
                sortable: true,
                body: this.translateValue,
            },
            {
                body: this.actionTemplate,
            },
        ];
    }

    handleDeleteRow(rowData) {
        return (
            <ActionLink
                className='p-link float-right'
                handleClick={(e) => this.handleOpenRemoveDialog(e, rowData.id)}
                variant='red'
                iconName='mdi-trash-can'
                iconSide='left'
                iconSize='xs'
                iconColor='red'
            />
        );
    }

    handleEditRow(rowData) {
        return (
            <ActionLink
                className='p-link float-right'
                handleClick={(e) => this.handleOpenGroupUsersDialog(e, rowData.id)}
                variant='red'
                iconName='mdi-pencil'
                iconSide='left'
                iconSize='xs'
                iconColor='red'
            />
        );
    }

    translateValue(rowData) {
        return rowData.name;
    }

    updateElement(data) {
        this.setState(
            {
                element: {
                    name: data.name,
                    value: data.value,
                    id: data.id,
                    version: data.version,
                },
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    breadCrumbItems() {
        return [{name: t('sidebar.groups'), url: '/group-users-list'}];
    }

    createOrUpdate() {
        const {element} = this.state;
        this.service
            .add(element)
            .then(() => {
                this.showSuccessMessage(t('groups.nameAdded'));
                this.refreshTable();
                this.handleOpenNewGroupDialog();
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                if (this.props.afterSave) {
                    this.props.afterSave();
                }
            });
        this.refreshTable();
        // }
    }

    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

GroupsListContainer.defaultProps = {
    detailUrl: '/groups/details',
    newUrl: '/groups/create',
    detailsUrl: '/groups/details',
    backUrl: '',
    lazy: true,
};

GroupsListContainer.propTypes = {
    detailUrl: PropTypes.string,
    detailsUrl: PropTypes.string,
    newUrl: PropTypes.string,
    backUrl: PropTypes.string,
    newGroup: PropTypes.string,
};

export default withRouter(withTranslation()(GroupsListContainer));
